import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleSoil = {
  namespaced: true,

  state: {
    name: 'Trencher',
    nextSeqCode: null,
    soils: [],
  },

  mutations,
  getters,
  actions
}

export default moduleSoil;